import type { BaseTheme } from 'ui/styles/theme.types';
import type { DeepPartial } from 'ui/helper/typescript-utils';

const theme: DeepPartial<BaseTheme> = {
  accents: {
    floatingShadow: '0 10px 10px rgb(0 0 0 / 0.05), 0 4px 3px rgb(0 0 0 / 0.13), 0 -1px 3px rgb(0 0 0 / 0.05)',
  },
  colors: {
    primaryLight: '#FFF7E1',
    primaryHover: '#DCCEA9',
    primaryMain: '#C8BA96',
    primaryDark: '#AEA17F',
  },
  colorVariants: {
    primary: ({ theme }: any) => theme.colors.primaryMain,
    secondary: '#C8BA96',
    background: '#13233e',
    hover: ({ theme }: any) => theme.colors.primaryHover,
    link: ({ theme }: any) => theme.colors.primaryMain,
    marker: ({ theme }: any) => theme.colorVariants.secondary,
    cta: ({ theme }: any) => theme.colorVariants.secondary,
  },
  sidebar: {
    color: ({ theme }: any) => theme.colorVariants.background,
  },
  sideOverlay: {
    color: ({ theme }: any) => theme.colorVariants.background,
  },
  cards: {
    borderRadius: '4px',
  },
  progressSteps: {
    iconColor: ({ theme }: any) => theme.colors.primaryMain,
    stepIndicatorColor: ({ theme }: any) => theme.colorVariants.secondary,
  },
  buttons: {
    size: {
      xsmall: {
        radius: 5,
      },
      small: {
        radius: 5,
      },
      large: {
        radius: 5,
      },
    },
  },
  forms: {
    // todo: hack! (this was from the theme.scss file, buttons still use the scss, so not needed for now)
    // .btn-outline-primary:not(:hover) {
    //   border-color: $link-color !important;
    //   color: $link-color !important;
    // }
  },
};

export default theme;
